import { createContext } from 'react'

interface LoadingContextType {
  isLoading: boolean
  startLoading: (key?: string) => void
  stopLoading: (key?: string) => void
  withLoading: <T>(asyncFn: () => Promise<T>, key?: string) => Promise<T>
}

export const LoadingContext = createContext<LoadingContextType | undefined>(undefined)
